module.exports = __webpack_public_path__ + "img/usdt.99b34179.svg";